export const s3BucketRootPath = "https://bcombs.s3.amazonaws.com";